'use client'

import type { api } from '@/convex/_generated/api'
import type { QuerySeed } from '@/lib/data/convex/query-seed'
import { createSeedBridge } from '@/lib/react/create-seed-bridge'

/**
 * `/integrations/[provider]`'s server read of the brand's connection row,
 * handed from the page's own Suspense boundary to `useIntegration` (inside
 * the static page body), which paints it until its subscription answers —
 * so a prefetched click shows the real connected state instead of flashing
 * "not connected". Shown only for the same org, brand and provider.
 */
type IntegrationConnectionSeed = QuerySeed<
  typeof api.integrations.queries.getByProvider
>

const integrationSeed = createSeedBridge<IntegrationConnectionSeed>()

export const useIntegrationConnectionSeed = integrationSeed.useSeed

export const IntegrationConnectionSeedBootstrap = integrationSeed.SeedBootstrap
